import { useTranslation } from 'react-i18next';
// assets
import { screen } from 'components/styles/variables';
import heroBg from 'public/static/images/about_us/about-us-hero.jpg';
import { flexBoxFullWidthCSS } from 'components/styles';

function Hero() {
  const { t } = useTranslation();

  return (
    <div className={`outer-container ${flexBoxFullWidthCSS.className}`}>
      <div className="background">
        <div className="overlay" />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-offset-2 col-lg-8 col-md-offset-2 col-md-8 col-sm-offset-1 col-sm-10">
            <div className="message-container">
              <div className="message-inner-container">
                <div className="message">{t('aboutUs.mission.title')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {flexBoxFullWidthCSS.styles}
      <style jsx>{`
        .outer-container {
          position: relative;
          height: 600px;
        }

        .background {
          position: absolute;
          top: 0;
          background: url(${heroBg}) center top;
          background-repeat: no-repeat;
          background-color: black;
          background-size: 1437px 600px;
          height: 100%;
          width: 100%;
        }

        .overlay {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.7);
        }

        .message-container {
          position: relative;
          top: 0;
          display: table;
          width: 100%;
          height: 600px;
        }

        .message-inner-container {
          display: table-cell;
          vertical-align: middle;
          text-align: center;
        }

        .message {
          color: white;
          font-size: 21px;
          text-transform: uppercase;
          border-top: 1px solid white;
          border-bottom: 1px solid white;
          padding: 30px 15px;
          text-align: center;
        }

        @media screen and (min-width: ${screen.smMin}) {
          .message {
            font-size: 24px;
          }
        }
      `}</style>
    </div>
  );
}

export default Hero;
